import axios from 'axios';

export default {
  post(packageObject){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/packages", packageObject)
      .then(results=>{
        return results.data;
      })
  },
  get(packageId) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/packages/${packageId}`)
    .then(results=>{
      return results.data;
    })
  },
  delete(packageId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/packages/"+packageId)
      .then(results=>{
        return results.data;
      })
  },
  fetch(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/packages", {params})
      .then(results=>{
        return results.data;
      })
  },
  init(packageId) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/packages/${packageId}/init`)
    .then(results=>{
      return results.data;
    })
  },
  confirm(packageId, confirmationNumber) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/packages/${packageId}/confirm`, { confirmationNumber })
    .then(results=>{
      return results.data;
    })
  },
  deliver(packageId, confirmationNumber) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/packages/${packageId}/deliver`)
    .then(results=>{
      return results.data;
    })
  },
  reject(packageId, confirmationNumber) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/packages/${packageId}/reject`)
    .then(results=>{
      return results.data;
    })
  },
  getReport(packageId, params, filename){
    const url = `${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/latest/admin/packages/${packageId}/report`;
  
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  }

}
